import { useModuleBEM } from "@b2bportal/core-themes";
import {
  usePremierDestinationHomepageBanner,
  type PremierDestinationHomepageBannerProps,
} from "@hsbc/portal";
import { Button, ButtonTypeEnum } from "@tenant/ui";
import clsx from "clsx";
import styles from "./styles.module.scss";

export const PremierDestinationHomepageBanner = (
  props: PremierDestinationHomepageBannerProps
) => {
  return <PremierDestinationBanner enableClick {...props} />;
};

export const PremierDestinationBanner: React.FC<
  PremierDestinationHomepageBannerProps & {
    enableClick?: boolean;
  }
> = ({ funnel, className, enableClick = false }) => {
  const [block, cn] = useModuleBEM(styles, "PremierDestinationBanner");

  const { titleMap, images, navigateToSearch, enabled } =
    usePremierDestinationHomepageBanner(funnel);

  const handleClick = () => {
    if (enableClick) {
      navigateToSearch();
    }
  };

  return enabled ? (
    <Button
      buttonType={ButtonTypeEnum.Wrap}
      onClick={handleClick}
      className={clsx(block, className)}
      disabled={!enableClick}
    >
      {/* request from hsbc to hide the logo for now */}
      {/* <img
        className={cn("logo")}
        src={images.logo}
        alt="Premier Destination Banner"
      /> */}
      <p className={cn("title")}>{titleMap[funnel]}</p>
    </Button>
  ) : null;
};
